module.exports = __webpack_public_path__ + "static/media/historia2.8bf78a40.png";